/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiInvestigationNote
 */
export interface InternalApiInvestigationNote {
    /**
     * 
     * @type {string}
     * @memberof InternalApiInvestigationNote
     */
    content: string;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiInvestigationNote
     */
    createdBy: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiInvestigationNote
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the InternalApiInvestigationNote interface.
 */
export function instanceOfInternalApiInvestigationNote(value: object): value is InternalApiInvestigationNote {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function InternalApiInvestigationNoteFromJSON(json: any): InternalApiInvestigationNote {
    return InternalApiInvestigationNoteFromJSONTyped(json, false);
}

export function InternalApiInvestigationNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiInvestigationNote {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'createdBy': InternalApiUserBasicDetailsFromJSON(json['createdBy']),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function InternalApiInvestigationNoteToJSON(json: any): InternalApiInvestigationNote {
    return InternalApiInvestigationNoteToJSONTyped(json, false);
}

export function InternalApiInvestigationNoteToJSONTyped(value?: InternalApiInvestigationNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
        'createdAt': value['createdAt'].toISOString(),
    };
}

